import { computed } from 'vue';

const usePropsAlias = (props) => {
  const initProps = {
    label: "label",
    key: "key",
    disabled: "disabled"
  };
  return computed(() => ({
    ...initProps,
    ...props.props
  }));
};

export { usePropsAlias };
//# sourceMappingURL=use-props-alias.mjs.map
